import {
  type Analytics,
  type CustomEventName,
  getAnalytics,
  logEvent,
} from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getPerformance } from 'firebase/performance';

const firebaseConfig = {
  apiKey: 'AIzaSyAfoS97Tt_zImTGjI9xYtSPwTJdJHEaKKE',
  authDomain: 'parranda-boricua-25b8f.firebaseapp.com',
  projectId: 'parranda-boricua-25b8f',
  storageBucket: 'parranda-boricua-25b8f.appspot.com',
  messagingSenderId: '98836019523',
  appId: '1:98836019523:web:ae82f3e6fa560daca357f6',
  measurementId: 'G-V5CD27YNXV',
};

let analytics: Analytics | null = null;

const ensureAnalytics = () => {
  if (!import.meta.env.PROD) return null;
  if (analytics) return analytics;

  const app = initializeApp(firebaseConfig);
  getPerformance(app);
  analytics = getAnalytics(app);
  return analytics;
};

export const logScreenView = (screenName: string) => {
  const analyticsInstance = ensureAnalytics();
  if (!analyticsInstance) return;

  logEvent(analyticsInstance, 'screen_view', {
    firebase_screen: screenName,
    firebase_screen_class: screenName,
  });
};

export const logAnalyticsEvent = <T extends string>(
  eventName: CustomEventName<T>,
  params?: Record<string, unknown>,
) => {
  const analyticsInstance = ensureAnalytics();
  if (!analyticsInstance) return;

  logEvent(analyticsInstance, eventName, params);
};
